// @flow

import {
  type UserInputValidationError,
  type UserInputValidatorArgs,
  onlyWhenSupport,
  VALID,
} from '@tectonics/prs/validation';

import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import { getCurrentPaymentMethodOptionalFields, hasOptionalField } from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';

import { validateNigerianPhoneNumber } from './nigerian-phone-number';
import { validateNigerianBankCode } from '@tectonics/prs/nigeria/validation/nigerian-bank-code';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);
  let optionalFields = incomingPayment.status === 'OP' ? getCurrentPaymentMethodOptionalFields(incomingPayment, userInputValues, spec) : [];

  switch (userInputName) {
    case 'nigerianPhoneNumber':
      if (!hasOptionalField(optionalFields, 'telephone')) {
        return onlyWhen('field_nigerian_phone_number') && validateNigerianPhoneNumber(userInputValue);
      }
      return null;

    case 'selectedBankCode':
      return validateNigerianBankCode(
        userInputValues.selectedPaymentMethod,
        userInputValues.selectedEWallet,
        userInputValues.selectedBankCode
      );

    default:
      return VALID;
  }
}
